<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="`maintenance-${_uid}`", @input="close")
      button.button.success(slot="trigger", v-if="request") Edit
      a.fa-stack.fa-lg(slot="trigger", v-else)
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      InterventionRequestForm(v-model="body", @input="check")
      ActionButton(slot="footer", :action="save") Save
      button.button.alert.float-right(slot="footer", @click="close(false)") Cancel
</template>

<script>
import DatePicker from '../../components/structure/DatePicker'
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import MaggieHelper from '../../maggieHelper'
import ActionButton from '../../components/structure/ui/ActionButton'
import SelectizeVehicle from "../../components/structure/ui/lists/selectize/SelectizeVehicle.vue";
import {EventBus} from "src/eventBus";
import InterventionRequestForm from "../../components/structure/forms/InterventionRequestForm.vue";
import DetailInterventionRequestReveal from "./DetailInterventionRequestReveal.vue";
import BookPanel from "../../components/structure/ui/BookPanel.vue";

export default {
  name: 'CreateInterventionRequestReveal',
  components: {
    BookPanel,
    DetailInterventionRequestReveal,
    InterventionRequestForm, SelectizeVehicle, ActionButton, ModalReveal, DatePicker
  },
  data() {
    return {
      body: {
        status: "NEW",
        linked_intervention_request_id: null,
        maintenance_driver_id: null,
        vehicle_id: null,
        priority: null,
        type: [],
        description: null,
        start_at: null,
        expiry: null,
        disable_vehicle_slot: false,
        create_reservation: false,
        has_linked_requests: false,
      },
    }
  },
  methods: {
    check() {
      if (this.body.has_linked_requests) {
        this.body.maintenance_driver_id = null
        this.body.expiry = null
        this.body.status = "NEW"
      }
    },
    save() {
      return KeplerBackofficeSdk.maintenanceRequest.make(this.body, () => {
        MaggieHelper.notification('', 'maintenance request created')

        EventBus.$emit('reload-list')
        EventBus.$emit('close-modal')
      })
    },
    close(val) {
      if (val !== false) {
        return
      }
      this.body = {
        status: "NEW",
        linked_intervention_request_id: null,
        maintenance_driver_id: null,
        vehicle_id: null,
        priority: null,
        type: [],
        description: null,
        start_at: null,
        expiry: null,
        disable_vehicle_slot: false,
        has_linked_requests: false,
      }
      EventBus.$emit('close-modal')
    }
  },
  computed: {},
  props: {
    request: null
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreateInterventionRequestReveal.vue?51b0fa2c